import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@material-ui/core";

export default function ContactNotesEditModal({ open, onClose, note = "", onSave }) {
  const [editedNote, setEditedNote] = useState("");

  useEffect(() => {
    if (open) {
      setEditedNote(note);
    }
  }, [note, open]);

  const handleSave = () => {
    onSave(editedNote);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Editar Observação</DialogTitle>
      <DialogContent>
        <TextField
          key={note}
          label="Editar Observação"
          fullWidth
          multiline
          rows={4}
          value={editedNote}
          onChange={(e) => setEditedNote(e.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
